import { env } from 'config';

const url = `${env.apiUrl}/v1/order-requisites`;

const getQrCodeUrl = (orderId: string) => `${url}/${orderId}/qr-code`;

const getQrImageUrl = (orderId: string, token: string) =>
  `${url}/${orderId}/qr-image?token=${token}`;

const formatPaymentLink = (paymentLink: string) => {
  try {
    const url = new URL(paymentLink);
    return url.hostname;
  } catch {
    return paymentLink;
  }
};

export const orderRequisitesUtils = {
  getQrCodeUrl,
  getQrImageUrl,
  formatPaymentLink,
};
